<div class="rename-market-form">
    <div class="form-row">
        <label>Market name</label>
        <input class="k-textbox" [(ngModel)]="newName" name="newName" autofocus />
    </div>
    <p class="error" *ngIf="error">{{ error }}</p>
    <p class="hint" *ngIf="!isNewMarket">
        This only renames the market on its own records. Nothing outside this screen reads
        markets by name yet, so there is nothing else to update.
    </p>
    <kendo-dialog-actions [layout]="'normal'">
        <button kendoButton (click)="onCancel()">Cancel</button>
        <button kendoButton [primary]="true" [disabled]="!!error" (click)="onRename()">{{ confirmLabel }}</button>
    </kendo-dialog-actions>
</div>
